import React from 'react';
import NumberInput from '../../../shared/NumberInput';
import DatePicker from '../../../shared/DatePicker';
import DynamicSearchSelect from '../../../shared/DynamicSearchSelect';
import { searchCustomerByIdNameMin } from '../../../../networking/NetworkingCustomers';
import { formatDate } from '../../../../helpers/FormatHelper';
import { getStyle, regularInputClass, regularSelectClass } from '../../../../styles/styles';
var style = getStyle();

export default class TicketSearchForm extends React.Component {    
    state = {        
        criteria: {
            ticketNro: '',
            CustomerIDName: '',
            valueDateFrom: '',
            valueDateTo: '',
            ticketType: '',
            CustomerID: '',
            customerList: [],
            ticketTypeList: [{name:'Incoming',value:'Incoming'},{name:'Outgoing',value:'Outgoing'}]
        }
    }
    

    componentDidUpdate(prevProps) {
        if ((prevProps.ticketType !== this.props.ticketType) ||
            (prevProps.valueDateFrom !== this.props.valueDateFrom) ||
            (prevProps.valueDateTo !== this.props.valueDateTo)
        ){
            this.setState({
                criteria: {
                    ...this.state.criteria,
                    ticketNro: '',
                    CustomerID: '',
                    valueDateFrom: this.props.valueDateFrom,
                    valueDateTo: this.props.valueDateTo,
                    ticketType: '',
                    CustomerIDName: '',
                }
            });
        }
    }

    
    searchCustomer(query) {
        searchCustomerByIdNameMin(query).then(
            (response) => {
                if (response.customers !== undefined) {
                    for (var i = 0; i < response.customers.length; i++) {
                        response.customers[i].value = response.customers[i].CustomerID;
                        response.customers[i].name = response.customers[i].CustomerIDName;
                    }
                    this.setState({ criteria: { ...this.state.criteria, customerList: response.customers} });
                }
            }
        )
    }

    handleUpdateticketNro(event) {
        this.setState({ criteria: { ...this.state.criteria, ticketNro: event.target.value } });
    }
    handleUpdateCustomerIDName(value) {
        if (value.value !== undefined) {
            this.setState({ criteria: { ...this.state.criteria, CustomerIDName: value.name !== 'select' ? value.name : '', CustomerID: value.value !== 'select' ? value.value : '' } });
        }else if (value.value === undefined){
            this.setState({ criteria: { ...this.state.criteria, CustomerIDName: '', CustomerID: '' } });
        }
    }
    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.handleSearchCriteriaClick();
        }
    };
    handleUpdateStatus(value) {
        if (value !== undefined) {
            this.setState({ criteria: { ...this.state.criteria, status: value.value !== 'select' ? value.value : '-1' } });
        } else {
            this.setState({ criteria: { ...this.state.criteria, status: '', } });
        }
    }
    handleUpdateticketType(value) {
        if (value !== undefined) {
            this.setState({ criteria: { ...this.state.criteria, ticketType: value.value !== 'select' ? value.value : '-1' } });
        } else {
            this.setState({ criteria: { ...this.state.criteria, ticketType: '', } });
        }
    }
    handleUpdateValueDateFrom(date) {
        if (date !== undefined) {
            this.setState({ criteria: { ...this.state.criteria, valueDateFrom: formatDate(date) } });
        } else {
            this.setState({ criteria: { ...this.state.criteria, valueDateFrom: '' } });
        }
    }
    handleUpdateValueDateTo(date) {
        if (date !== undefined) {
            this.setState({ criteria: { ...this.state.criteria, valueDateTo: formatDate(date) } });
        } else {
            this.setState({ criteria: { ...this.state.criteria, valueDateTo: '' } });
        }
    }
    
    //CLEAR CRITERIA
    handleClearCriteriaClick(event) {
        event.preventDefault();
        this.setState({
            criteria: {
                ...this.state.criteria,
                ticketNro: '',
                CustomerID: '',
                valueDateFrom: '',
                valueDateTo: '',
                ticketType: '',
                CustomerIDName: '',
            }
        });
        this.props.clearGrid();
    }

    //SEARCH CRITERIA
    handleSearchCriteriaClick(event) {
        var objFilter = {
            TicketNo: this.state.criteria.ticketNro === '' ? null : this.state.criteria.ticketNro,
            CustomerID: this.state.criteria.CustomerID,
            //CustomerName: this.state.criteria.CustomerIDName === '' ? null : this.state.criteria.CustomerIDName,
            DeliveryDateFrom: this.state.criteria.valueDateFrom === '' ? null : this.state.criteria.valueDateFrom,
            DeliveryDateTo: this.state.criteria.valueDateTo === '' ? null : this.state.criteria.valueDateTo,
            ticketType: this.state.criteria.ticketType === '' ? null : this.state.criteria.ticketType
        };
        this.props.searchDealsGrid(objFilter);
    }
    
    render() {
        var classNameInputName = regularInputClass;
        var classNameSelect = regularSelectClass;

        return (
            <div>                
                <div className="uk-form-stacked uk-grid">

                    <div className="uk-width-1-6 uk-form-stacked">
                        <label className="uk-form-label" htmlFor="form-order-orderNo">Ticket No</label>
                        <div className="" style={style.inputStyle}>
                            <NumberInput className={classNameInputName} id="ticketNro" placeholder="0" type="Integer" value={this.state.criteria.ticketNro} onChange={this.handleUpdateticketNro.bind(this)} 
                                autoFocus={true} onKeyPress={this.handleKeyPress} />
                        </div>
                    </div>
                    
                    <div className="uk-width-1-6 uk-form-stacked">
                        <label className="uk-form-label" htmlFor="form-order-CustomerIDName">Customer</label>
                        <div className="" style={style.inputStyle}>
                            <DynamicSearchSelect id="CustomerIDName2" placeholder="Customer" searchFunction={this.searchCustomer.bind(this)} getValue={this.handleUpdateCustomerIDName.bind(this)} 
                                data={this.state.criteria.customerList} objValue={{ value: this.state.criteria.CustomerID, name: this.state.criteria.CustomerIDName }} />
                        </div>
                    </div>                
                    
                    {/*<div className="uk-width-1-6 uk-form-stacked">
                        <label className="uk-form-label" htmlFor="form-order-ticketType">ticketType</label>
                        <div className="" style={style.inputStyle}>
                            <DynamicSelect className={classNameSelect} objValue={{ value: this.state.criteria.ticketType }} getValue={this.handleUpdateticketType.bind(this)} 
                            placeholder={"Select an item..."} listHasPlaceholder={false} data={this.state.criteria.ticketTypeList} id="form-order-ticketType" />
                        </div>
                    </div>*/}

                    <div className="uk-width-1-6 uk-form-stacked">
                        <label className="uk-form-label" htmlFor="form-order-valueDateFrom">Date From</label>
                        <div className="" style={style.inputStyle}>
                            <DatePicker className={classNameInputName} value={this.state.criteria.valueDateFrom} onDayChange={this.handleUpdateValueDateFrom.bind(this)} />
                        </div>
                    </div>

                    <div className="uk-width-1-6 uk-form-stacked">
                        <label className="uk-form-label" htmlFor="form-order-valueDateTo">Date To</label>
                        <div className="" style={style.inputStyle}>
                            <DatePicker className={classNameInputName} value={this.state.criteria.valueDateTo} onDayChange={this.handleUpdateValueDateTo.bind(this)} />
                        </div>
                    </div>

                    
                    <div className="uk-width-1-1">
                        <button className="uk-button uk-button-green" onClick={this.handleClearCriteriaClick.bind(this)}>Clear Fields</button>
                        <button className="uk-button uk-button-green" onClick={this.handleSearchCriteriaClick.bind(this)}>Search</button>
                    </div>

                </div>
            </div>
        );
    }

}